export const appBaseURL = "/"

export const appCdnURL = "https://form.finvens.io"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, maximum-scale=1, minimum-scale=1, initial-scale=1"},{"charset":"utf-8"}],"link":[],"style":[],"script":[],"noscript":[],"viewport":"width=device-width, maximum-scale=1, minimum-scale=1, initial-scale=1"}

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"